/* @flow */
import type {Action} from "../action";

const DefaultState = {
  graphicalTool: null
};

function setGraphicalMode(state, payload) {
  return {
    graphicalTool: payload
  };
}

type State = {
  graphicalTool: "horizontalLine"
};

function graphicalMode(state: State = DefaultState, action: Action): State {
  switch (action.type) {
    case "SET_GRAPHICAL_MODE":
      return setGraphicalMode(state, action.payload);
    case "PUSH_GRAPHICAL_TOOL":
      return {
        graphicalTool: null
      };
    default:
      return state;
  }
}

export default graphicalMode;



// WEBPACK FOOTER //
// ./src/redux/reducer/graphicalMode.js